import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RecordCommsOptInEventMutationVariables = Types.Exact<{
  type: Types.CommsOptInEventType;
}>;


export type RecordCommsOptInEventMutation = { __typename?: 'Mutation', recordCommsOptInEvent: { __typename?: 'CommsOptInMutationResult', success: boolean } };


export const RecordCommsOptInEventDocument = gql`
    mutation RecordCommsOptInEvent($type: CommsOptInEventType!) {
  recordCommsOptInEvent(type: $type) {
    success
  }
}
    `;
export type RecordCommsOptInEventMutationFn = Apollo.MutationFunction<RecordCommsOptInEventMutation, RecordCommsOptInEventMutationVariables>;

/**
 * __useRecordCommsOptInEventMutation__
 *
 * To run a mutation, you first call `useRecordCommsOptInEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordCommsOptInEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordCommsOptInEventMutation, { data, loading, error }] = useRecordCommsOptInEventMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRecordCommsOptInEventMutation(baseOptions?: Apollo.MutationHookOptions<RecordCommsOptInEventMutation, RecordCommsOptInEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordCommsOptInEventMutation, RecordCommsOptInEventMutationVariables>(RecordCommsOptInEventDocument, options);
      }
export type RecordCommsOptInEventMutationHookResult = ReturnType<typeof useRecordCommsOptInEventMutation>;
export type RecordCommsOptInEventMutationResult = Apollo.MutationResult<RecordCommsOptInEventMutation>;
export type RecordCommsOptInEventMutationOptions = Apollo.BaseMutationOptions<RecordCommsOptInEventMutation, RecordCommsOptInEventMutationVariables>;